import Integration from "../layouts/Integration";
import AppPage from "../layouts/App";
import NoContext from "../layouts/NoContext";
import NotFound from "../layouts/NotFound";

// There is no catalogue. Every screen is scoped to one app and one account,
// both of which come off the URL the CRM sends the user to.
//
//   /integration/:appId?code=…               marketplace install callback
//   /app/:appId?locationId=…&companyId=…     the installed app's page
//
// The install callback paints its own full-page background, so it uses the
// "blank" layout; everything else gets the top bar via "default".
const routes = [
  {
    key: "integration",
    path: "/integration/:appId",
    element: <Integration />,
    layout: "blank",
  },
  // A redirect URI registered without the appId segment would otherwise fall
  // through to the catch-all; this way the callback itself explains the fix.
  {
    key: "integration-no-app",
    path: "/integration",
    element: <Integration />,
    layout: "blank",
  },
  {
    key: "app",
    path: "/app/:appId",
    element: <AppPage />,
    layout: "default",
  },
  {
    key: "root",
    path: "/",
    element: <NoContext />,
    layout: "default",
  },
  {
    key: "not-found",
    path: "*",
    element: <NotFound />,
    layout: "default",
  },
];

export { routes };
